import React from 'react';
import './activities.css';
import { connect } from 'react-redux';
import {
  updateActivityFilter,
  updateSelectedActivity
} from '../../../actions/adminActions/activitiesActions.js';
import { activities } from '../../../apis/backend.js'; //make sure to include this for each page
import EditActivityModal from './activitiesModals/editActivityModal.jsx';
import AddActivityModal from './activitiesModals/addActivityModal.jsx';

class Activities extends React.Component {
  async activityDeleteRequest(id) {
    await activities
      .delete(`/${id}`, {
        headers: { authorization: this.props.employeeToken }
      })
      .catch((response) => {
        console.log(response);
      });
  }

  renderactivities() {
    //renders the activities table
    return (
      <>
        {/* {console.log(this.props.activities)} */}
        {this.props.activities
          .filter((activity) => {
            const filterString = `${activity.name}`;
            // console.log(activity.name, activity);
            return filterString.toLowerCase().indexOf(this.props.activityFilter.toLowerCase()) > -1;
          })
          .map((activity) => (
            <tr key={this.props.activities.indexOf(activity)}>
              <td className="text-center" style={{ width: '24%' }}>
                {`${activity.name}`}
              </td>
              <td className="text-center permission-super-admin " style={{ width: '9%' }}>
                <div
                  data-target="#exampleModal"
                  className="btn btn-sm btn-dark"
                  data-toggle="modal"
                  onClick={() => {
                    this.props.updateSelectedActivity(activity.id);
                  }}
                >
                  Edit
                </div>
              </td>
              <td className="text-center permission-super-admin " style={{ width: '9%' }}>
                <div
                  className="btn btn-sm btn-dark"
                  data-target="#deleteModal"
                  data-toggle="modal"
                  onClick={() => {
                    this.props.updateSelectedActivity(activity.id);
                  }}
                >
                  Remove
                </div>
              </td>
            </tr>
          ))}
      </>
    );
  }

  getActivityName() {
    const activity = this.props.activities.find((obj) => obj.id === this.props.selectedActivity);

    return activity ? activity.name : '';
  }

  render() {
    return (
      <div className="activities-page">
        <div className="container">
          <div
            className="form-inline md-form form-sm mt-4"
            style={{ fontSize: '36px', color: '#fff' }}
          >
            <div style={{ margin: 'auto', height: '48px', width: '100%' }}>Activities</div>
          </div>
          <div className="form-inline md-form form-sm mt-3">
            <input
              value={this.props.activityFilter}
              className="form-control form-control-lg w-45"
              type="text"
              placeholder="Search"
              aria-label="Search"
              onChange={(e) => {
                this.props.updateActivityFilter(e.target.value);
              }}
            />
            <div
              data-target="#addModal"
              className="btn btn-lg btn-dark permission-super-admin"
              data-toggle="modal"
              style={{ marginLeft: '10px' }}
            >
              Add Activity
            </div>
          </div>
          <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table className="table table-striped  table-bordered table-hover bg-white mt-1 mr-3">
              <thead className="bg-dark thead-dark">
                <tr>
                  <th className="text-center" style={{ width: '24%' }}>
                    Name
                  </th>
                  <th className="text-center permission-super-admin " style={{ width: '9%' }}>
                    Edit
                  </th>
                  <th className="text-center permission-super-admin " style={{ width: '9%' }}>
                    Remove
                  </th>
                </tr>
              </thead>
              <tbody>{this.renderactivities()}</tbody>
            </table>
          </div>
        </div>

        <AddActivityModal />
        <EditActivityModal />

        <div className="modal fade" id="deleteModal" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content" style={{ width: '80%', margin: '0 auto' }}>
              <div className="modal-header">
                <h5 className="modal-title">Are you Sure?</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    this.props.updateSelectedActivity(0);
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body" style={{ textAlign: 'center', fontSize: '18px' }}>
                <strong>&apos;{this.getActivityName()}&apos;</strong> will be deleted forever!!
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.activityDeleteRequest(this.props.selectedActivity);
                    this.props.updateSelectedActivity(0);
                  }}
                >
                  Yes
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.props.updateSelectedActivity(0);
                  }}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  activities: state.admin.admin.activities,
  activityFilter: state.admin.activities.activityFilter,
  selectedActivity: state.admin.activities.selectedActivity,
  employeeToken: state.auth.employeeToken
});

export default connect(mapStateToProps, {
  updateActivityFilter,
  updateSelectedActivity
})(Activities);
